import axios from 'axios'
import * as constant from '../constant'
import Auth from './Auth'

const url = constant.BASE_URL
const url_video = constant.BASE_URL_VIDEO

const makeFullUrl = path => {
  return (path.startsWith("/video/") ? url_video : url) + path
}

export const login = (username, password) => {
  return axios.get(
    makeFullUrl("/auth/login"),
    {
      withCredentials: true,
      auth: {
        username,
        password,
      },
    }
  )
}

export const preLogin = (username) => {
  return axios.post(
    makeFullUrl("/auth/preLogin"),
    { username },
  )
}

export const get = param => {
  const headers = {
    token: Auth.getToken(),
  }

  return axios.get(
    makeFullUrl(param),
    { headers },
  )
}

export const getBlob = param => {
  const headers = {
    token: Auth.getToken(),
  }

  return axios.get(
    makeFullUrl(param),
    { headers, responseType: "blob" },
  )
}

export const post = (param, json) => {
  const headers = {
    token: Auth.getToken(),
    "Content-Type": "application/json",
  }

  return axios.post(
    makeFullUrl(param),
    JSON.stringify(json),
    { headers },
  )
}

export const postFormData = (param, formData) => {
  const headers = {
    token: Auth.getToken(),
    'Content-Type': 'multipart/form-data',
  }

  return axios.post(
    makeFullUrl(param),
    formData,
    { headers },
  )
}

export const put = (param, json) => {
  const headers = {
    token: Auth.getToken(),
    "Content-Type": "application/json",
  }

  return axios.put(
    makeFullUrl(param),
    JSON.stringify(json),
    { headers },
  )
}

export const destroy = (param) => {
  const headers = {
    token: Auth.getToken(),
  }

  return axios.delete(
    makeFullUrl(param),
    { headers },
  )
}

export const download = (param) => {
  const headers = {
    token: Auth.getToken(),
  }

  return axios.get(
    makeFullUrl(param),
    { headers },
  )
}